(function () {
  'use strict';
  /* cbp-quiz build 2026-07-13-v6 */

  var CBP_QUIZ_QUESTIONS = [
    {
      id: 'breed',
      title: 'Q1. わんちゃんの犬種を教えてください',
      options: [
        { value: 'toy_poodle', label: 'トイプードル' },
        { value: 'chihuahua', label: 'チワワ' },
        { value: 'maltese', label: 'マルチーズ' },
        { value: 'pomeranian', label: 'ポメラニアン' },
        { value: 'yorkshire_terrier', label: 'ヨークシャーテリア' },
        { value: 'shih_tzu', label: 'シーズー' },
        { value: 'dachshund', label: 'ダックスフンド' },
        { value: 'papillon', label: 'パピヨン' },
        { value: 'french_bulldog', label: 'フレンチブルドッグ' },
        { value: 'cavalier', label: 'キャバリア' },
        { value: 'bichon_frise', label: 'ビションフリーゼ' },
        { value: 'miniature_schnauzer', label: 'ミニチュアシュナウザー' },
        { value: 'pekingese', label: 'ペキニーズ' },
        { value: 'jack_russell', label: 'ジャックラッセルテリア' },
        { value: 'italian_greyhound', label: 'イタリアングレーハウンド' },
        { value: 'mameshiba', label: '豆柴' },
        { value: 'mix', label: 'ミックス' },
        { value: 'other', label: 'その他' },
      ],
      twoColumns: true,
      threeColumns: true,
    },
    {
      id: 'coat_color',
      title: 'Q2. 毛色を教えてください',
      options: [
        { value: 'white', label: 'ホワイト系' },
        { value: 'cream', label: 'クリーム系' },
        { value: 'apricot', label: 'アプリコット系' },
        { value: 'brown', label: 'ブラウン系' },
        { value: 'chocolate', label: 'チョコレート系' },
        { value: 'black', label: 'ブラック系' },
        { value: 'gray', label: 'グレー系' },
        { value: 'silver', label: 'シルバー系' },
        { value: 'red', label: 'レッド系' },
        { value: 'parti', label: 'パーティーカラー' },
        { value: 'tan', label: 'タン系' },
        { value: 'mix_color', label: 'ミックスカラー' },
      ],
      twoColumns: true,
      threeColumns: true,
    },
    {
      id: 'coat_length',
      title: 'Q3. 毛の長さを教えてください',
      options: [
        { value: 'short', label: '短毛' },
        { value: 'medium', label: '中毛' },
        { value: 'long', label: '長毛' },
      ],
      twoColumns: true,
    },
    {
      id: 'size',
      title: 'Q4. 体重・サイズを教えてください',
      options: [
        { value: 'xs', label: '〜2kg' },
        { value: 's', label: '2〜4kg' },
        { value: 'm', label: '4〜7kg' },
        { value: 'l', label: '7kg以上' },
      ],
      twoColumns: true,
    },
    {
      id: 'outfit',
      title: 'Q5. 合わせたいお洋服はありますか？',
      options: [
        { value: 'dress', label: 'ワンピース' },
        { value: 'casual', label: 'カジュアル服' },
        { value: 'frill_lace', label: 'フリル・レース系' },
        { value: 'kimono_yukata', label: '着物・浴衣' },
        { value: 'no_clothes', label: '服なし' },
        { value: 'undecided', label: 'まだ決めていない' },
      ],
      twoColumns: true,
    },
    {
      id: 'mood',
      title: 'Q6. どんな雰囲気にしたいですか？',
      options: [
        { value: 'cute', label: 'とにかくかわいく' },
        { value: 'elegant', label: '上品に' },
        { value: 'gorgeous', label: 'ゴージャスに' },
        { value: 'natural', label: 'ナチュラルに' },
        { value: 'photogenic', label: '写真映え重視' },
        { value: 'favorite_color', label: '推しカラーで選びたい' },
      ],
      twoColumns: true,
    },
    {
      id: 'scene',
      title: 'Q7. どんなシーンで使いたいですか？',
      options: [
        { value: 'daily', label: '普段のおしゃれ' },
        { value: 'outing', label: 'お出かけ' },
        { value: 'anniversary', label: '誕生日・記念日' },
        { value: 'sns', label: 'SNS撮影' },
        { value: 'gift', label: 'プレゼント' },
        { value: 'seasonal', label: '季節イベント' },
      ],
      twoColumns: true,
    },
  ];

  var CBP_QUIZ_LABELS = {
    coat_color: {
      white: 'ホワイト系',
      cream: 'クリーム系',
      apricot: 'アプリコット系',
      brown: 'ブラウン系',
      chocolate: 'チョコレート系',
      black: 'ブラック系',
      gray: 'グレー系',
      silver: 'シルバー系',
      red: 'レッド系',
      parti: 'パーティーカラー',
      tan: 'タン系',
      mix_color: 'ミックスカラー',
    },
    coat_length: {
      short: '短い被毛',
      medium: 'ふんわりした中毛',
      long: '長めのふんわり被毛',
    },
    outfit: {
      dress: 'ワンピース',
      casual: 'カジュアル服',
      frill_lace: 'フリル・レース系のお洋服',
      kimono_yukata: '着物・浴衣',
      no_clothes: 'お洋服なしのナチュラルコーデ',
      undecided: 'お洋服',
    },
    mood: {
      cute: 'かわいらしい',
      elegant: '上品な',
      gorgeous: 'ゴージャスな',
      natural: 'ナチュラルな',
      photogenic: '写真映えする',
      favorite_color: 'お気に入りカラーの',
    },
    scene: {
      daily: '普段のおしゃれ',
      outing: 'お出かけ',
      anniversary: '誕生日や記念日のフォト',
      sns: 'SNS撮影',
      gift: 'プレゼント',
      seasonal: '季節のイベント',
    },
  };

  var CBP_QUIZ_COLOR_SUGGESTIONS = {
    white: 'PINKやWHITE系',
    cream: 'CREAMやPINK系',
    apricot: 'PINKやPEACH系',
    brown: 'やわらかいPINKやWHITE系',
    chocolate: 'GOLDやBROWN系',
    black: 'パールやゴールド系',
    gray: 'ラベンダーやパステル系',
    silver: 'パールやWHITE系',
    red: 'REDやPINK系',
    parti: 'マルチカラーやパステル系',
    tan: 'BEIGEやBROWN系',
    mix_color: 'マルチカラーやパステル系',
  };

  function cbpQuizParseList(value) {
    if (!value) return [];
    // list型の配列・カンマ区切り文字列の両方に対応
    var raw = Array.isArray(value) ? value.join(',') : String(value);
    return raw
      .split(',')
      .map(function (item) {
        return item.trim().toLowerCase();
      })
      .filter(Boolean);
  }

  function cbpQuizIncludes(list, value) {
    if (!value) return false;
    return list.indexOf(String(value).toLowerCase()) !== -1;
  }

  function cbpQuizMatchesDimension(list, value) {
    if (!list.length) return false;
    if (!value) return false;
    var normalized = String(value).toLowerCase();
    if (list.indexOf(normalized) !== -1) return true;
    if (normalized === 'mix' || normalized === 'other') {
      return list.indexOf('mix') !== -1 || list.indexOf('other') !== -1;
    }
    return false;
  }

  function cbpQuizHasRecommendationConfig(product) {
    return !!(
      product.recommendedBreeds.length ||
      product.recommendedCoatColors.length ||
      product.recommendedCoatLengths.length ||
      product.recommendedSizes.length ||
      product.recommendedOutfits.length ||
      product.recommendedMoods.length ||
      product.recommendedScenes.length
    );
  }

  function cbpQuizGetDisplayPriority(product) {
    var priority = parseInt(product.displayPriority, 10);
    return isNaN(priority) ? 99 : priority;
  }

  function cbpQuizCompareRanked(a, b) {
    if (b.score !== a.score) return b.score - a.score;
    return cbpQuizGetDisplayPriority(a.product) - cbpQuizGetDisplayPriority(b.product);
  }

  function cbpQuizIsEligible(product, answers) {
    var checks = [
      [product.recommendedBreeds, answers.breed],
      [product.recommendedCoatColors, answers.coat_color],
      [product.recommendedCoatLengths, answers.coat_length],
      [product.recommendedSizes, answers.size],
      [product.recommendedOutfits, answers.outfit],
      [product.recommendedMoods, answers.mood],
      [product.recommendedScenes, answers.scene],
    ];

    for (var i = 0; i < checks.length; i++) {
      var list = checks[i][0];
      var answer = checks[i][1];
      if (list.length && !cbpQuizMatchesDimension(list, answer)) {
        return false;
      }
    }

    return true;
  }

  function cbpQuizCompareByPriority(a, b) {
    return cbpQuizGetDisplayPriority(a.product) - cbpQuizGetDisplayPriority(b.product);
  }

  function cbpQuizScoreProduct(product, answers) {
    var score = 0;
    var attributeScore = 0;

    function addIfMatch(list, answer, points) {
      if (!list.length) return;
      if (!cbpQuizMatchesDimension(list, answer)) return;
      score += points;
      attributeScore += points;
    }

    addIfMatch(product.recommendedBreeds, answers.breed, 2);
    addIfMatch(product.recommendedCoatColors, answers.coat_color, 4);
    addIfMatch(product.recommendedCoatLengths, answers.coat_length, 2);
    addIfMatch(product.recommendedSizes, answers.size, 2);
    addIfMatch(product.recommendedOutfits, answers.outfit, 3);
    addIfMatch(product.recommendedMoods, answers.mood, 4);
    addIfMatch(product.recommendedScenes, answers.scene, 2);
    if (product.isBeginnerFriendly && attributeScore > 0) {
      score += 1;
    }

    return score;
  }

  function cbpQuizGetType(answers) {
    var moodTypes = {
      cute: 'ふんわりプリンセスタイプ',
      elegant: '上品クラシカルタイプ',
      photogenic: '写真映えアイドルタイプ',
      natural: 'ナチュラルかわいいタイプ',
      gorgeous: '甘めラグジュアリータイプ',
      favorite_color: 'ふんわりプリンセスタイプ',
    };

    if (moodTypes[answers.mood]) {
      return moodTypes[answers.mood];
    }
    if (answers.scene === 'outing') {
      return 'おでかけガーリータイプ';
    }
    if (answers.size === 'xs') {
      return '小さなレディタイプ';
    }
    return 'ふんわりプリンセスタイプ';
  }

  function cbpQuizBuildReason(answers) {
    var colorLabel = CBP_QUIZ_LABELS.coat_color[answers.coat_color] || 'お選びの毛色';
    var lengthLabel = CBP_QUIZ_LABELS.coat_length[answers.coat_length] || 'ふんわりした被毛';
    var outfitLabel = CBP_QUIZ_LABELS.outfit[answers.outfit] || 'お洋服';
    var moodLabel = CBP_QUIZ_LABELS.mood[answers.mood] || 'かわいらしい';
    var sceneLabel = CBP_QUIZ_LABELS.scene[answers.scene] || 'おしゃれ';
    var colorSuggestion = CBP_QUIZ_COLOR_SUGGESTIONS[answers.coat_color] || 'パステル系';

    var reason =
      colorLabel +
      'の毛色と' +
      lengthLabel +
      'には、' +
      colorSuggestion +
      'のバレッタがよく映えます。';

    if (answers.outfit !== 'undecided' && answers.outfit !== 'no_clothes') {
      reason += outfitLabel + 'とも相性がよく、';
    } else if (answers.outfit === 'no_clothes') {
      reason += 'ナチュラルなお洋服なしコーデにも合わせやすく、';
    }

    reason += moodLabel + '雰囲気を叶える' + sceneLabel + 'にもおすすめです。';
    return reason;
  }

  function cbpQuizRankProducts(products, answers) {
    if (!products.length) return [];

    var eligible = products.filter(function (product) {
      return cbpQuizIsEligible(product, answers);
    });

    if (!eligible.length) {
      eligible = products.slice();
    }

    var ranked = eligible
      .map(function (product) {
        return {
          product: product,
          score: cbpQuizScoreProduct(product, answers),
        };
      })
      .sort(cbpQuizCompareRanked);

    var configured = ranked.filter(function (entry) {
      return cbpQuizHasRecommendationConfig(entry.product);
    });

    var matched = ranked.filter(function (entry) {
      return entry.score > 0;
    });

    var pool = matched;

    if (!pool.length && configured.length) {
      pool = configured.slice().sort(cbpQuizCompareByPriority);
    }

    if (!pool.length) {
      pool = ranked.slice().sort(cbpQuizCompareByPriority);
    }

    return pool.slice(0, 3).map(function (entry) {
      return entry.product;
    });
  }

  function cbpQuizNormalizeProduct(product) {
    var displayPriority = parseInt(product.displayPriority, 10);
    if (isNaN(displayPriority)) displayPriority = 99;

    return {
      productId: product.productId,
      title: product.title || '',
      url: product.url || '#',
      image: product.image || '',
      price: product.price || '',
      variantId: product.variantId,
      available: !!product.available,
      hasOnlyDefaultVariant: !!product.hasOnlyDefaultVariant,
      recommendedBreeds: cbpQuizParseList(product.recommendedBreeds),
      recommendedCoatColors: cbpQuizParseList(product.recommendedCoatColors),
      recommendedCoatLengths: cbpQuizParseList(product.recommendedCoatLengths),
      recommendedSizes: cbpQuizParseList(product.recommendedSizes),
      recommendedOutfits: cbpQuizParseList(product.recommendedOutfits),
      recommendedMoods: cbpQuizParseList(product.recommendedMoods),
      recommendedScenes: cbpQuizParseList(product.recommendedScenes),
      isBeginnerFriendly: !!product.isBeginnerFriendly,
      displayPriority: displayPriority,
    };
  }

  function cbpQuizLoadProductsInline(root) {
    var productsEl = root.querySelector('[data-cbp-quiz-products]');
    var raw = productsEl ? productsEl.textContent.trim() : '';

    if (raw && raw.indexOf('Liquid error') === -1) {
      try {
        var parsed = JSON.parse(raw);
        if (Array.isArray(parsed) && parsed.length) {
          return parsed;
        }
      } catch (error) {
        /* fall through to product bank */
      }
    }

    return Array.prototype.map
      .call(root.querySelectorAll('[data-cbp-quiz-product-bank-item][data-cbp-quiz-product-json]'), function (item) {
        try {
          return JSON.parse(item.getAttribute('data-cbp-quiz-product-json') || '');
        } catch (error) {
          return null;
        }
      })
      .filter(Boolean);
  }

  function cbpQuizBuildDataUrl(baseUrl, page) {
    var url = String(baseUrl || '');
    var joiner = url.indexOf('?') === -1 ? '?' : '&';
    return url + joiner + 'page=' + page;
  }

  function cbpQuizFetchAllProducts(dataUrl) {
    if (!dataUrl || !window.fetch) {
      return Promise.resolve([]);
    }

    var products = [];

    function fetchPage(page) {
      return fetch(cbpQuizBuildDataUrl(dataUrl, page), {
        credentials: 'same-origin',
        headers: { Accept: 'application/json, text/plain, */*' },
      })
        .then(function (response) {
          if (!response.ok) {
            throw new Error('quiz data fetch failed: ' + response.status);
          }
          return response.text();
        })
        .then(function (text) {
          var data = JSON.parse(text.trim());
          if (data.products && data.products.length) {
            products = products.concat(data.products);
          }
          var currentPage = parseInt(data.page, 10) || page;
          var totalPages = parseInt(data.pages, 10) || currentPage;
          if (currentPage < totalPages) {
            return fetchPage(currentPage + 1);
          }
          return products;
        });
    }

    return fetchPage(1).catch(function () {
      return [];
    });
  }

  function cbpQuizLoadProducts(root, config) {
    return cbpQuizFetchAllProducts(config.productsDataUrl).then(function (fetched) {
      if (fetched.length) {
        return fetched;
      }
      return cbpQuizLoadProductsInline(root);
    });
  }

  function cbpQuizInit(root) {
    var config = {};
    try {
      config = JSON.parse(root.getAttribute('data-cbp-quiz-config') || '{}');
    } catch (error) {
      config = {};
    }

    var products = [];
    var productsReady = false;

    var state = {
      step: 0,
      answers: {},
      view: 'intro',
    };

    var introPanel = root.querySelector('[data-cbp-quiz-panel="intro"]');
    var quizPanel = root.querySelector('[data-cbp-quiz-panel="quiz"]');
    var resultPanel = root.querySelector('[data-cbp-quiz-panel="result"]');
    var questionTitle = root.querySelector('[data-cbp-quiz-question-title]');
    var optionsList = root.querySelector('[data-cbp-quiz-options]');
    var stepBadge = root.querySelector('[data-cbp-quiz-step-badge]');
    var quizVisual = root.querySelector('[data-cbp-quiz-visual]');
    var backBtn = root.querySelector('[data-cbp-quiz-back]');
    var nextBtn = root.querySelector('[data-cbp-quiz-next]');
    var startBtn = root.querySelector('[data-cbp-quiz-start]');
    var resetBtn = root.querySelector('[data-cbp-quiz-reset]');
    var resultType = root.querySelector('[data-cbp-quiz-result-type]');
    var resultReason = root.querySelector('[data-cbp-quiz-result-reason]');
    var productsWrap = root.querySelector('[data-cbp-quiz-products-wrap]');
    var productBank = root.querySelector('[data-cbp-quiz-product-bank]');
    var shareWrap = root.querySelector('[data-cbp-quiz-share]');
    var questionWrap = root.querySelector('.cbp-quiz__question-wrap');

    function cbpQuizGetStickyHeaderOffset() {
      var header =
        document.querySelector('sticky-header') ||
        document.querySelector('.shopify-section-header-sticky') ||
        document.querySelector('.header-wrapper');

      if (!header) return 0;

      var headerInner = header.querySelector('.header') || header;
      return headerInner.getBoundingClientRect().height || 0;
    }

    function scrollQuizToQuestion() {
      var target = quizVisual || questionWrap || quizPanel;
      if (!target) return;

      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(function () {
          var offset = cbpQuizGetStickyHeaderOffset() + 16;
          var top = window.scrollY + target.getBoundingClientRect().top - offset;
          window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
        });
      });
    }

    function setActivePanel(view) {
      state.view = view;
      [introPanel, quizPanel, resultPanel].forEach(function (panel) {
        if (!panel) return;
        panel.classList.toggle('is-active', panel.getAttribute('data-cbp-quiz-panel') === view);
        panel.setAttribute('aria-hidden', panel.getAttribute('data-cbp-quiz-panel') === view ? 'false' : 'true');
      });
    }

    function getCurrentQuestion() {
      return CBP_QUIZ_QUESTIONS[state.step];
    }

    function updateStepIndicator() {
      var current = state.step + 1;
      var total = CBP_QUIZ_QUESTIONS.length;
      if (stepBadge) stepBadge.textContent = 'STEP ' + current;
      if (quizVisual) {
        quizVisual.setAttribute('data-cbp-quiz-visual-step', String(state.step));
      }
    }

    function renderQuestion(shouldScrollToQuestion) {
      var question = getCurrentQuestion();
      if (!question || !optionsList || !questionTitle) return;

      questionTitle.textContent = question.title;
      questionTitle.id = 'cbp-quiz-question-' + question.id;
      optionsList.innerHTML = '';
      optionsList.classList.toggle('cbp-quiz__options--cols-2', !!question.twoColumns && !question.threeColumns);
      optionsList.classList.toggle('cbp-quiz__options--cols-3', !!question.threeColumns);
      optionsList.setAttribute('role', 'radiogroup');
      optionsList.setAttribute('aria-labelledby', questionTitle.id);

      question.options.forEach(function (option, index) {
        var li = document.createElement('li');
        var button = document.createElement('button');
        button.type = 'button';
        button.className = 'cbp-quiz__option';
        button.setAttribute('role', 'radio');
        button.setAttribute('aria-checked', state.answers[question.id] === option.value ? 'true' : 'false');
        button.setAttribute('data-value', option.value);
        button.textContent = option.label;

        if (state.answers[question.id] === option.value) {
          button.classList.add('is-selected');
        }

        button.addEventListener('click', function () {
          state.answers[question.id] = option.value;
          renderQuestion();
          updateNavButtons();
        });

        button.addEventListener('keydown', function (event) {
          var buttons = Array.prototype.slice.call(optionsList.querySelectorAll('.cbp-quiz__option'));
          var currentIndex = buttons.indexOf(button);
          if (event.key === 'ArrowRight' || event.key === 'ArrowDown') {
            event.preventDefault();
            var next = buttons[currentIndex + 1] || buttons[0];
            next.focus();
          }
          if (event.key === 'ArrowLeft' || event.key === 'ArrowUp') {
            event.preventDefault();
            var prev = buttons[currentIndex - 1] || buttons[buttons.length - 1];
            prev.focus();
          }
          if (event.key === ' ' || event.key === 'Enter') {
            event.preventDefault();
            button.click();
          }
        });

        li.appendChild(button);
        optionsList.appendChild(li);

        if (index === 0 && !state.answers[question.id]) {
          button.tabIndex = 0;
        } else {
          button.tabIndex = state.answers[question.id] === option.value ? 0 : -1;
        }
      });

      updateStepIndicator();
      updateNavButtons();
      questionTitle.focus();

      if (shouldScrollToQuestion) {
        scrollQuizToQuestion();
      }
    }

    function updateNavButtons() {
      var question = getCurrentQuestion();
      var hasAnswer = question && !!state.answers[question.id];

      if (backBtn) {
        backBtn.disabled = state.step === 0;
      }
      if (nextBtn) {
        nextBtn.disabled = !hasAnswer;
        nextBtn.textContent = state.step === CBP_QUIZ_QUESTIONS.length - 1 ? '診断結果を見る' : '次へ';
      }
    }

    function buildProductCardHtml(product) {
      var soldOutClass = product.available ? '' : ' cbd-product-card--sold-out';
      var soldOutBadge = product.available
        ? ''
        : '<span class="cbd-product-card__soldout">SOLD OUT</span>';
      var imageHtml = product.image
        ? '<img src="' +
          escapeHtml(product.image) +
          '" alt="' +
          escapeHtml(product.title) +
          '" loading="lazy" width="600" height="600">'
        : '';

      return (
        '<article class="cbd-product-card' +
        soldOutClass +
        '">' +
        '<a href="' +
        escapeHtml(product.url) +
        '" class="cbd-product-card__media">' +
        soldOutBadge +
        imageHtml +
        '</a>' +
        '<div class="cbd-product-card__body">' +
        '<a href="' +
        escapeHtml(product.url) +
        '" class="cbd-product-card__title">' +
        escapeHtml(product.title) +
        '</a>' +
        '<p class="cbd-product-card__price">' +
        escapeHtml(product.price) +
        '</p>' +
        '</div>' +
        '</article>'
      );
    }

    function renderProducts(recommended) {
      if (!productsWrap) return;

      productsWrap.innerHTML = '';

      if (!recommended.length) {
        var emptyItem = document.createElement('li');
        emptyItem.className = 'cbp-quiz__empty-item';
        emptyItem.innerHTML =
          '<p class="cbp-quiz__empty">' +
          (products.length
            ? '該当するおすすめ商品が見つかりませんでした。商品のメタフィールド（診断マッチ条件）をご確認ください。'
            : '診断に表示できる商品がありません。商品の「診断に表示する」がOFFになっていないか確認してください。') +
          '</p>';
        productsWrap.appendChild(emptyItem);
        return;
      }

      recommended.forEach(function (product) {
        var item = document.createElement('li');
        item.className = 'cbd-product-grid__item';

        var bankItem = productBank
          ? productBank.querySelector(
              '[data-cbp-quiz-product-bank-item][data-product-id="' + product.productId + '"]'
            )
          : null;
        var cardWrap = bankItem ? bankItem.querySelector('.cbp-quiz__product-card-wrap') : null;

        if (cardWrap) {
          item.appendChild(cardWrap.cloneNode(true));
        } else {
          var wrap = document.createElement('div');
          wrap.className = 'cbp-quiz__product-card-wrap';
          wrap.innerHTML = buildProductCardHtml(product);
          item.appendChild(wrap);
        }

        productsWrap.appendChild(item);
      });
    }

    function escapeHtml(text) {
      return String(text)
        .replace(/&/g, '&amp;')
        .replace(/</g, '&lt;')
        .replace(/>/g, '&gt;')
        .replace(/"/g, '&quot;');
    }

    function renderShare(resultLabel) {
      if (!shareWrap) return;

      var shareUrl = window.location.href.split('#')[0];
      var shareText = 'うちの子に似合うバレッタ診断 結果は「' + resultLabel + '」でした！';
      var encodedUrl = encodeURIComponent(shareUrl);
      var encodedText = encodeURIComponent(shareText + ' ' + shareUrl);

      shareWrap.innerHTML =
        '<p class="cbp-quiz__share-label">診断結果をシェア</p>' +
        '<div class="cbp-quiz__share-actions">' +
        '<a class="cbp-quiz__share-btn" href="https://twitter.com/intent/tweet?url=' +
        encodedUrl +
        '&text=' +
        encodeURIComponent(shareText) +
        '" target="_blank" rel="noopener noreferrer">X</a>' +
        '<a class="cbp-quiz__share-btn" href="https://www.facebook.com/sharer/sharer.php?u=' +
        encodedUrl +
        '" target="_blank" rel="noopener noreferrer">Facebook</a>' +
        '<a class="cbp-quiz__share-btn" href="https://line.me/R/msg/text/?' +
        encodedText +
        '" target="_blank" rel="noopener noreferrer">LINE</a>' +
        '<button type="button" class="cbp-quiz__share-btn cbp-quiz__share-btn--copy" data-cbp-quiz-copy-url="' +
        escapeHtml(shareUrl) +
        '">リンクをコピー</button>' +
        '</div>';

      var copyButton = shareWrap.querySelector('[data-cbp-quiz-copy-url]');
      if (copyButton) {
        copyButton.addEventListener('click', function () {
          var url = copyButton.getAttribute('data-cbp-quiz-copy-url');
          if (!url) return;

          var finishCopy = function () {
            copyButton.textContent = 'コピーしました';
            window.setTimeout(function () {
              copyButton.textContent = 'リンクをコピー';
            }, 1800);
          };

          if (navigator.clipboard && window.isSecureContext) {
            navigator.clipboard.writeText(url).then(finishCopy).catch(function () {});
          } else {
            var input = document.createElement('input');
            input.value = url;
            document.body.appendChild(input);
            input.select();
            document.execCommand('copy');
            document.body.removeChild(input);
            finishCopy();
          }
        });
      }

      shareWrap.hidden = false;
    }

    function showResults() {
      var recommended = cbpQuizRankProducts(products, state.answers);
      var resultLabel = cbpQuizGetType(state.answers);
      if (resultType) resultType.textContent = resultLabel;
      if (resultReason) resultReason.textContent = cbpQuizBuildReason(state.answers);
      renderProducts(recommended);
      renderShare(resultLabel);
      setActivePanel('result');
      if (resultType) resultType.focus();
      root.scrollIntoView({ behavior: 'smooth', block: 'start' });
    }

    function startQuiz() {
      if (!productsReady) return;
      state.step = 0;
      setActivePanel('quiz');
      updateStepIndicator();
      renderQuestion(true);
    }

    function goNext() {
      var question = getCurrentQuestion();
      if (!question || !state.answers[question.id]) return;

      if (state.step < CBP_QUIZ_QUESTIONS.length - 1) {
        state.step += 1;
        renderQuestion(true);
        return;
      }
      showResults();
    }

    function goBack() {
      if (state.step === 0) return;
      state.step -= 1;
      renderQuestion(true);
    }

    function resetQuiz() {
      state.step = 0;
      state.answers = {};
      if (shareWrap) {
        shareWrap.hidden = true;
        shareWrap.innerHTML = '';
      }
      setActivePanel('intro');
    }

    function setStartEnabled(enabled) {
      if (!startBtn) return;
      startBtn.disabled = !enabled;
      if (!enabled) {
        startBtn.setAttribute('aria-busy', 'true');
      } else {
        startBtn.removeAttribute('aria-busy');
      }
    }

    if (startBtn) startBtn.addEventListener('click', startQuiz);
    if (nextBtn) nextBtn.addEventListener('click', goNext);
    if (backBtn) backBtn.addEventListener('click', goBack);
    if (resetBtn) resetBtn.addEventListener('click', resetQuiz);

    setActivePanel('intro');
    setStartEnabled(false);

    cbpQuizLoadProducts(root, config).then(function (loaded) {
      products = loaded.map(cbpQuizNormalizeProduct);
      productsReady = true;
      setStartEnabled(true);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('[data-cbp-quiz]').forEach(cbpQuizInit);
  });
})();
